<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let title = "";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="editor-composite">
	<span class="title"> {title} </span>
	<slot />
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.editor-composite {
		display: flex;
		flex-direction: column;
		gap: 10px;

		.title {
			font-size: 0.875rem;
			color: #6d6f76;
		}
	}

	@include DesktopSize {
		.editor-composite {
			.title {
				font-size: 1rem;
			}
		}
	}

</style>
